(() => {
  const guard = '__aluwaRapidBundleDrawerFixV1';
  if (window[guard]) return;
  window[guard] = true;

  const bundleProperty = 'input[name="properties[_rapi_bundles]"]';
  const serumCheckbox = '.rapi-cross-sell-native-check:checked';
  const serumLinkSelector = '.rapi-cross-sell-list__title[href*="/products/serum-visage"], a[href*="/products/serum-visage"]';
  const activeForms = new WeakSet();

  function findFormAndButton(event) {
    if (event.type === 'submit' && event.target instanceof HTMLFormElement) {
      return { form: event.target, button: event.submitter || event.target.querySelector('button[type="submit"]') };
    }

    const target = event.target instanceof Element ? event.target.closest('button[type="submit"], input[type="submit"]') : null;
    return target?.form ? { form: target.form, button: target } : null;
  }

  function showMessage(form, message) {
    let node = form.querySelector('[data-aluwa-cart-message]');
    if (!node) {
      node = document.createElement('p');
      node.dataset.aluwaCartMessage = '';
      node.setAttribute('role', 'status');
      node.setAttribute('aria-live', 'polite');
      node.style.cssText = 'margin:8px 0;color:#315B4A;font-size:13px;line-height:1.4;';
      form.append(node);
    }
    node.textContent = message;
  }

  function getLineAttributes(formData) {
    const attributes = new Map();
    for (const [name, value] of formData.entries()) {
      const match = name.match(/^properties\[(.+)\]$/);
      if (!match || (typeof File !== 'undefined' && value instanceof File)) continue;
      attributes.set(match[1], String(value));
    }
    return Array.from(attributes, ([key, value]) => ({ key, value }));
  }

  async function addBundleAndSerum(event) {
    const match = findFormAndButton(event);
    if (!match) return;

    const { form, button } = match;
    if (!form.querySelector(bundleProperty) || !document.querySelector(serumCheckbox)) return;

    const actions = window.Shopify?.actions;
    if (typeof actions?.updateCart !== 'function' || typeof actions?.openCart !== 'function') return;

    const formData = new FormData(form);
    const merchandiseId = String(formData.get('id') || '').trim();
    if (!merchandiseId) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (activeForms.has(form)) return;
    activeForms.add(form);

    const wasDisabled = Boolean(button?.disabled);
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }

    try {
      const quantityValue = Number.parseInt(String(formData.get('quantity') || '1'), 10);
      const bundleLine = {
        merchandiseId,
        quantity: Number.isFinite(quantityValue) && quantityValue > 0 ? quantityValue : 1,
        attributes: getLineAttributes(formData),
      };

      let serumLine = null;
      let serumWarning = '';
      const serumLink = document.querySelector(serumLinkSelector);

      if (serumLink) {
        const serumUrl = new URL(serumLink.getAttribute('href'), window.location.origin);
        serumUrl.pathname = serumUrl.pathname.replace(/\/$/, '') + '.js';
        serumUrl.search = '';

        try {
          const productResponse = await fetch(serumUrl.toString(), {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
          });
          if (!productResponse.ok) throw new Error('Le sérum est momentanément indisponible.');
          const serumProduct = await productResponse.json();
          const availableVariant = (serumProduct.variants || []).find((variant) => variant.available);
          if (availableVariant) {
            serumLine = { merchandiseId: String(availableVariant.id), quantity: 1 };
          } else {
            serumWarning = 'Le sérum n’est pas disponible pour le moment.';
          }
        } catch (error) {
          serumWarning = 'Le sérum n’a pas pu être ajouté. L’huile sera ajoutée au panier.';
          console.error('[ALUWA] Impossible de récupérer le variant du sérum.', error);
        }
      } else {
        serumWarning = 'Le sérum n’a pas pu être trouvé. L’huile sera ajoutée au panier.';
      }

      const lines = serumLine ? [serumLine, bundleLine] : [bundleLine];
      const result = await actions.updateCart(
        { lines },
        { event: { context: 'product', detail: { source: 'aluwa-rapid-bundle-cross-sell' } } }
      );

      if (result?.userErrors?.length) {
        throw new Error(result.userErrors[0].message || 'Le panier n’a pas pu être mis à jour.');
      }

      if (serumWarning) showMessage(form, serumWarning);
      else if (result?.warnings?.length) showMessage(form, result.warnings[0].message || 'Vérifie les articles ajoutés au panier.');

      await actions.openCart();
    } catch (error) {
      console.error('[ALUWA] Ajout du bundle au tiroir impossible.', error);
      showMessage(form, error?.message || 'Une erreur est survenue. Réessaie.');
    } finally {
      activeForms.delete(form);
      if (button) {
        button.removeAttribute('aria-busy');
        if (!wasDisabled) button.disabled = false;
      }
    }
  }

  window.addEventListener('click', addBundleAndSerum, true);
  window.addEventListener('submit', addBundleAndSerum, true);
})();